import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { 
	TableColumn, 
	DateTableColumn, 
	TableComponent, 
	DataReloadEvent, 
	LoginService, 
	CheckboxComponent, 
	TableElement, 
	NativeStateComponent 
} from '@serengeti/serengeti-common';
import { TranslateService } from '@ngx-translate/core';
import { SchedulerTaskService } from '../service/scheduler.task.service';
import { MatDialog } from '@angular/material/dialog';
import { TaskConfigVariableDialog } from './task.config.variable.dialog';

@Component({
	selector: 'app-service-scheduler-task-template',
	templateUrl: './task.component.html',
	styleUrls: ['./task.component.scss']
})
export class SchedulerTaskComponent implements OnInit {

	@Input() scheduler: any;
	
	columns: TableColumn[];

	_searchControl: ElementRef;
	@ViewChild('search', { static: false }) set searchControl(_searchControl: ElementRef) {
		this._searchControl = _searchControl;
		if (_searchControl) {
			_searchControl.nativeElement.addEventListener('keypress', (e: KeyboardEvent) => {
				if (e.key === "Enter") {
					this.doSearch();
				}
			});
		}
	}
	get searchControl() {
		return this._searchControl;
	}
	oldSearchName: string;

	_taskTemplateList: TableComponent;
	@ViewChild('taskTemplateList', {static: false}) set taskTemplateList(_taskTemplateList: TableComponent) {
		this._taskTemplateList = _taskTemplateList;

		this.doSearch();
	}

	get taskTemplateList(): TableComponent {
		return this._taskTemplateList;
	}

	currentCondition: DataReloadEvent;
	searchName: string;

	constructor(
		public dialog: MatDialog,
		private taskService: SchedulerTaskService,
		private loginService: LoginService,
		private translateService: TranslateService
	) {
		this.columns = [
			new TableColumn('id', 'service.scheduler.task.content.columns.id')
			.withValueVisible(false).withType(CheckboxComponent),
			new TableColumn('state', 'service.scheduler.task.content.columns.state')
			.withType(NativeStateComponent)
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const state = TableColumn._getData(_element.getData(), 'state');
				if (state === 'Active') {
					_element.getData()._nativeState = 'status active';
					return 'common.active-state.options.Active';
				} else {
					_element.getData()._nativeState = 'status inactive';
					return 'common.active-state.options.Inactive';
				}
			}),
			new TableColumn('name', 'service.scheduler.task.content.columns.name'),
			new DateTableColumn('createdDate', 'service.scheduler.task.content.columns.created-date')
		];
	}

	ngOnInit() {
	}

	doConfigTask(task: any) {
		const configDialog = this.dialog.open(TaskConfigVariableDialog, {
			width: '70%',
			height: '80vh',
			data: task
		});

		configDialog.afterClosed().subscribe(result => {
			if (result && result.result === true) {
			}
		});
	}

	doRemoveTask(task: any) {
		this.scheduler.tasks.splice(this.scheduler.tasks.indexOf(task), 1);
	}

	doSearch() {
		if (this.oldSearchName && this.searchName === this.oldSearchName) {
			return;
		}

		if (this.taskTemplateList) {
			const sortItem = this.loginService.getScreenConfig('scheduler.task', 'sortItem');
			const sortOrder = this.loginService.getScreenConfig('scheduler.task', 'sortOrder');

			this.oldSearchName = this.searchName;
			this.doRefresh(new DataReloadEvent((sortItem ? sortItem : 'createdDate'), (sortOrder ? sortOrder : 'desc'),
				0, this.taskTemplateList.pageSize, this.searchName));
		}
	}

	doRefresh(condition?: DataReloadEvent) {
		if (condition) {
			this.currentCondition = condition;
		} else {
			condition = this.currentCondition;
		}

		if (condition.pageNumber === 0) {
			this.loginService.setScreenConfig('scheduler.task', 'sortItem', condition.active);
			this.loginService.setScreenConfig('scheduler.task', 'sortOrder', condition.sortOrder);
		}

		this.taskService.search(condition.filter, condition.active, condition.sortOrder, condition.pageNumber, condition.pageSize)
			.subscribe(resultPage => {
			this.taskTemplateList.refresh(resultPage.totalElements, resultPage.content, this.columns, condition);
		});
	}

	doCheck($event: any) {
		$event.element.setSelected(!$event.element.isSelected());
	}

	doAdd() {
		const list: TableElement[] = this.taskTemplateList.getElements();

		if (!this.scheduler.tasks) {
			this.scheduler.tasks = [];
		}

		let noTask = true;
		list.forEach((item: any) => {
			if (item.isSelected()) {
				noTask = false;
			}
		});

		if (noTask) {
			this.translateService.get('service.scheduler.task.alert.no-task-selected').subscribe((message: string) => {
				alert(message);
			});
			return;
		} else {
			list.forEach((item: any) => {
				if (item.isSelected()) {
					const task = item.getData();
	
					this.scheduler.tasks.push({
						name: task.name,
						description: task.description,
						template: task,
						variables: task.variables.map((variable: any) => {
							return {
								name: variable.name,
								callOrder: variable.callOrder,
								mandatory: variable.mandatory,
								description: variable.description,
								variableId: variable.id,
								variableType: variable.variable.variableType,
								variableName: variable.variable.variableName,
								variableValue: null,
								variableText: null,
								variable: variable.variable
							}
						})
					});
				}
			});	
		}
	}

}

